import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

export interface registerRequest {
    category: string;
    subject: string;
    bl_no: string;
    company: string;
    contents: string;
    bigo: string;
    phone: string;
    list_no: string;
}

export interface registerResponse {
    statusCode: number;
    message: string;
}

export const usePutRegister = (
    successCallback?: (data: registerResponse) => void,
): UseMutationResult<registerResponse, Error, registerRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<registerResponse, Error, registerRequest>({
        mutationFn: async (registerData: registerRequest) => {
            const response = await axiosInstance.put(enum_api_uri.put_register, registerData);
            return response.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["usePostRequestList"] });
            successCallback?.(data);
        },
    });
};
